<template>
  <div class="mw-split-container">

    <mw-dialog size="large_large"  :title=" id ? '编辑权限' : '新建权限' "
    ref="limitTree"  :before-close="handleClose" :close-on-click-modal="false">

      <div class="mw-toolbar">
        <el-button  type="primary" @click="saveGroup"> <i class="fa fa-file-text"></i>  保存</el-button>
      </div>

      <div class="mw-toolbar__body">

        <role ref="role"  :openDialog="openDialog" :groupId="id" :showDefultBtn='showDefultBtn'  :deptInfo="deptInfo"></role>

      </div>

    </mw-dialog>
    <mw-dialog ref="impDialog" title="导入角色管理数据" size="mini_small" :footerButton="impBtton">
      <div class="mw-dialog_body" style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item label="导入说明:">
              <template>
                第一步：单击此处<el-button @click="downloadExcel" >下载模版</el-button><br/>
                第二步：按照模板格式录入角色管理数据;<br/>
                第三步：上传模板文件:
              </template>
            </el-form-item>
            <el-form-item label="上传文件:">
              <template>
                <el-upload ref="importData"
                           :on-success="importSuccessCallback"
                           style="display: inline-block;"
                           :auto-upload="false"
                           :action="importAction"
                           multiple
                           :headers="headers"
                           :limit="1">
                  <el-button >获取文件</el-button>
                  <div slot="tip" style="" class="el-upload__tip">只能上传.xls/.xlsx文件</div>
                </el-upload>
              </template>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>
    <split-pane :defaultSize="358" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">

           <div class="mw-toolbar">
              <el-button @click="expand"  v-show="expandFlag==1" size="mini"><i class="fa fa-angle-double-down"></i>展开</el-button>
              <el-button @click="closed"  v-show="expandFlag!=1" size="mini"><i class="fa fa-angle-double-up"></i>折叠</el-button>
              <el-button @click="toGroup" size="mini"><i class="fa fa-file-text-o"></i>分类显示</el-button>
           </div>

          <div class="mw-toolbar__body">
            <mw-tree :url="unitTreeUrl" :defaultParams="defaultParams" :autoLoad="false" :async="false" :multiple="false"   :selectFirst="true" :dragEnable="true"
                   :expandedFirst="true"   @changed="loadTableTree" ref="unitTree"
            ></mw-tree>
          </div>

        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">

           <toolbar-table :layout="layout" :autoLoad="false" ref="dataTable" >
             <span slot="dropDown">
               <el-dropdown trigger="hover" @command="handleMoreCommand" >
                 <el-button class="el-dropdown-link">
                   更多<i class="el-icon-caret-bottom el-icon--right"></i>
                 </el-button>
                 <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                   <el-dropdown-item command="import" >导入</el-dropdown-item>
                   <el-dropdown-item command="export">导出</el-dropdown-item>
                 </el-dropdown-menu>
               </el-dropdown>
             </span>
           </toolbar-table>

        </div>
      </template>
    </split-pane>

  </div>
</template>
<script>
  import role from "./user/roleInf.vue"
  import { mapGetters } from 'vuex';
  export default {

    components: {
     role
    },
    data() {
      let me = this;
      return {
        layout: [],
        expandFlag:1,
        loading: false,
        firstTime: true,
        openDialog: false,
        change: false,
        defaultParams:{deep:true,isContainSelf:true,parentId:""},
        unitTreeUrl: 'api/org/getUnitTreeContainSelf',
        id: '',
        deptInfo: '',
        showDefultBtn:'',
        importAction:'/api/org/importJobRoleFromExcel',
        savingGroup: false,
        impBtton:[ {
          label: "取消",
          func:this.impCancel,
          type: "default"
        },
          {
            label: "导入",
            func: this.import
          }],
        headers: {},
        treeData:[]
      }
    },

      mounted() {
       let me = this;
       me.layout = [
         [{
         span:0,
         type: 'menu',
         label: '角色管理列表',
         api: 'org.listGroupPagingByAuthType',
         columns: [
          {type: 'selection'},{type: 'index'},
          {slot:{type:"href",func: me.editRole},prop: 'name',label: '角色名称',tooltip: true},
          {prop: 'roleNames', label: '角色权限'},
          {prop: 'userNames', label: '用户人员'},
          {prop: 'dec', label: '描述'}
        ]
       },{
         span: 8,
         type: 'button',
         items: [{
           label: '添加',
           icon: 'fa fa-plus-square',
           func: me.addRole
         },
        {
           label: '删除',
           icon:'fa fa-trash-o fa-fw',
           func: me.deleteGroup
         }
         ],
        suffixSlot:"dropDown"
       },{
         span: 6,
         type: 'searchText',
         offset: 10,
         name:'name'
       }]
       ]
      var isSysAdmin = this.isSysAdmin();
      if(this.userInfo.developer || isSysAdmin){
        this.defaultParams.parentId = ""//this.userInfo.owner; 根目录有多个就不显示其它的单位了所以注释掉
      }else{
        if(this.userInfo.loginUnitModel)
           this.defaultTreeParams.unitId = this.userInfo.loginUnitModel.id;
        if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
          this.defaultParams.parentId = this.$store.getters.curUnit[0].id;
        }
      }
      this.mwRef("unitTree").renderTree();
     },

    methods: {
      addRole(){
        this.id = '';
        this.mwRef('limitTree').show();
        this.openDialog = true;
      },
      isSysAdmin(){
        if(this.userInfo.roles && this.userInfo.roles.length>0){
          for(var i=0;i<this.userInfo.roles.length;i++){
            if(this.userInfo.roles[i].name=="系统管理员"){
              return true;
            }
          }
        }
        return false;
      },
      editRole(row){
        this.id = row.id;
        this.mwRef('limitTree').show();
     },

      saveGroup() {
        if (this.savingGroup) return;
        if(this.mwRef('role').valid()){
          let group = this.mwRef('role').getValue();
          if(group.postRoleIds==""&&group.docRoleIds==""&&group.flowRoleIds==""){
            this.mwMsg('warning','权限角色至少选择一个');
            return;
          }
          this.savingGroup = true;
          this.mwApi.org.saveGroup(group).then(data => {
            if (data.success) {
              this.mwMsg('权限保存成功');

              this.refresh();
              this.handleClose();
              this.openDialog = false;
            } else {
              this.mwMsg('权限组保存失败')
            }
            this.savingGroup = false;
        });

       }else{
          this.mwMsg('warning', '请输入完整信息');
       }

      },

      handleClose(){
        this.id = '';
        this.mwRef('role').resetFields();
        this.mwRef('limitTree').hide();
      },

      deleteGroup(data) {
        let me = this;
         if (data.length == 0) {
          this.mwMsg('info','请选择你要操作的角色')
        }
        else {
          this.$confirm('是否要删除此角色?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
          let arrIds = [];
          data.forEach((val) => {
            arrIds.push(val.id);
          });
          this.mwApi.org.deleteGroup(arrIds).then(res => {
            if (res.success) {
              this.mwMsg('删除成功!');
              this.refresh();
            }
            else{
              this.mwMsg('info','删除成功!');
            }

          })    }).catch(() => {});
      }
  },


    loadTableTree(data){
      var me = this;
      this.deptInfo = {code: data.id,unitId: data.id,unitName: data.name};
      //判断是否存在默认角色,存在则隐藏默认角色按钮
      var params = {code:data.id,start:0,limit:2000};
      this.mwApi.org.listGroupPagingByAuthType(params).then(res => {
        this.showDefultBtn = '1';
        for(var y=0;y<res.result.length;y++){
          if(res.result[y].name=="默认角色"){
            this.showDefultBtn = '';
          }
        }
      })
      this.mwRef('dataTable').refreshTableDefaultParams({ code : data.id});
    },


    refresh() {
      this.mwRef('dataTable').refreshTableDefaultParams({ code : this.deptInfo.code});
      // this.mwRef('unitTree').refresh();
    },
    expand() {
      this.expandFlag = 2;
      this.mwRef('unitTree').openAll();
    },
    closed() {
      this.expandFlag = 1;
      this.mwRef('unitTree').closeAll();
    },
    toGroup(){
      //this.$router.push({ path: '/set/group'})
      //因切换后开发环境导航点组织机构没有切换，所以开发环境用户还是原先的路由
       if(!window["$servicePath"]){
         this.$router.push({ path: '/org/group'})
       }else{
          var p=this.$parent;
           do{
               if(p.changeView){
                 p.changeView("systemSet_org_group");
               }
                   p=p.$parent;
           }while(p);
       }
    },
    handleMoreCommand(command){
        let me=this;
        if(command === 'import'){
          this.mwRef('impDialog').show();
        }
        if(command === 'export'){
          let dataTable = me.mwRef('dataTable');
          let multipleSelection = dataTable.getMultipleSelection();
          if(multipleSelection && multipleSelection.length >0){
            let groupIds = [];
            multipleSelection.forEach((val) => {
              groupIds.push(val.id);
            });
            me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportJobRoleToExcel"),{},false,PF.encode({groupIds:groupIds}));
          }else{
            let data;
            if(this.mwRef('unitTree').getSelected()){
              data = this.mwRef('unitTree').getSelected();
            }else{
              me.mwMsg('请选择要导出的单位节点!');
              return;
            }
            me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportJobRoleToExcel"),{codes:[data.id]},false,"");
          }
        }
      },
    import(){
        let me=this;
        me.mwRef("importData").submit();
      },
    impCancel(){
        this.mwRef('impDialog').hide();
      },
    importSuccessCallback(response, file, fileList) {
        if (this.mwRef("importData") && typeof this.mwRef("importData").clearFiles == 'function') this.mwRef("importData").clearFiles();
        if(response.result){
          this.mwRef('unitTree').refresh();
          PF.show('message',{html:response.result.errMsg});
          this.mwRef('impDialog').hide();
        }
      },
    downloadExcel(){
        var me = this;
        me.mwUtil.downloadAttachment("/template_file/importJobRoleExcel.xls");
      }
    },
    computed: {
    ...mapGetters([
        'userInfo',
        'expUser'
      ]),
    },
    watch: {

    }

  }
</script>
<style scoped>



  .el-tree-node__content .el-checkbox {
    display: none;
  }



</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/roleList.vue